import React from "react";
import PropTypes from "prop-types";
import { has } from 'lodash';

const Footer = ({ question = {} }) => {
    let className = "w3-panel w3-opacity" + (has(question, "class") ? " " + question.class : " w3-large w3-center");

    if (question && has(question, "footer") && question.footer) {
        return (
            <div id="footer" className={className} style={{ whiteSpace: 'pre-wrap' }}>{question.footer}</div>
        );
    }

    return null;
};

Footer.propTypes = {
    question: PropTypes.object
};

export default Footer;
